/**
 * Ids wiring the Navigator's combobox to its popup, per the APG combobox pattern:
 * the input carries `aria-controls` pointing at the listbox, and
 * `aria-activedescendant` pointing at the highlighted option inside it.
 */
export const NAVIGATOR_SEARCH_INPUT_ID = "navigator-search-input";
export const NAVIGATOR_SEARCH_LISTBOX_ID = "navigator-search-listbox";
